import { CheckCircle2, AlertCircle, XCircle } from 'lucide-react'

export type ProductSeoStatus = 'green' | 'yellow' | 'red'

export function getProductSeoStatus(
  name: string,
  description: string,
  images: string[]
): ProductSeoStatus {
  let score = 0
  if (name.trim().length >= 10) score++
  if (description.trim().length >= 100) score++
  if (images.length > 0) score++
  if (score === 3) return 'green'
  if (score >= 1) return 'yellow'
  return 'red'
}

const STATUS_CONFIG = {
  green: {
    label: 'SEO Baik',
    hint: 'Nama, deskripsi, dan gambar sudah memenuhi rekomendasi dasar.',
    bg: 'bg-emerald-50 border-emerald-200',
    text: 'text-emerald-800',
    Icon: CheckCircle2,
  },
  yellow: {
    label: 'SEO Cukup',
    hint: 'Lengkapi nama (min. 10 karakter), deskripsi (min. 100 karakter), dan gambar produk.',
    bg: 'bg-amber-50 border-amber-200',
    text: 'text-amber-800',
    Icon: AlertCircle,
  },
  red: {
    label: 'SEO Kurang',
    hint: 'Tambahkan nama yang jelas, deskripsi lengkap, dan minimal satu foto produk.',
    bg: 'bg-red-50 border-red-200',
    text: 'text-red-800',
    Icon: XCircle,
  },
} as const

type Props = {
  name: string
  description: string
  images: string[]
}

export function ProductSeoScore({ name, description, images }: Props) {
  const status = getProductSeoStatus(name, description, images)
  const config = STATUS_CONFIG[status]
  const Icon = config.Icon

  const checks = [
    { ok: name.trim().length >= 10, label: 'Nama produk min. 10 karakter' },
    { ok: description.trim().length >= 100, label: 'Deskripsi min. 100 karakter' },
    { ok: images.length > 0, label: 'Ada gambar produk' },
  ]

  return (
    <div className={`rounded-lg border p-3 ${config.bg}`}>
      <div className={`flex items-center gap-2 font-medium text-sm ${config.text}`}>
        <Icon className="w-4 h-4 shrink-0" />
        Indikator SEO: {config.label}
      </div>
      <p className={`text-xs mt-1 ${config.text} opacity-90`}>{config.hint}</p>
      <ul className="mt-2 space-y-1">
        {checks.map((c) => (
          <li key={c.label} className={`text-xs flex items-center gap-1.5 ${c.ok ? 'text-emerald-700' : 'text-gray-500'}`}>
            {c.ok ? <CheckCircle2 className="w-3 h-3" /> : <span className="w-3 h-3 rounded-full border border-gray-300 inline-block" />}
            {c.label}
          </li>
        ))}
      </ul>
    </div>
  )
}
